const products = [
  {
    id: 1,
    image: "/images/blog1.webp",
    name: "Logitech G203 Wired 8000 DPI For PC/Mac",
    price: 50,
    discount: 10,
    category: "Electronics",
    features: {
      weight: "1.5kg",
      dimensions: "10x8x2 inches",
      color: "Black",
      batteryLife: "8 hours",
      screenSize: "15 inches",
    },
    colors: ["black", "aliceblue", "red"],
  },
  {
    id: 2,
    image: "/images/blog2.webp",
    name: "Logitech G203 Wired 8000 DPI For PC/Mac",
    price: 70,
    discount: 20,
    category: "Home & Kitchen",
    features: {
      weight: "2kg",
      dimensions: "12x10x4 inches",
      color: "White",
      powerConsumption: "60W",
      capacity: "1.5 liters",
    },
    colors: ["yellow", "blue", "green"],
  },
  {
    id: 3,
    image: "/images/blog3.webp",
    name: "Logitech G203 Wired 8000 DPI For PC/Mac",
    price: 90,
    discount: 0,
    category: "Clothing",
    features: {
      material: "Cotton",
      size: "Medium",
      color: "Blue",
      washType: "Machine washable",
      style: "Casual",
    },
    colors: ["#ffaaee", "#faafaf", "#f0f"],
  },
];

export default products;
